import { render, staticRenderFns } from "./CourseListPanel.vue?vue&type=template&id=48583387&scoped=true&"
import script from "./CourseListPanel.vue?vue&type=script&lang=js&"
export * from "./CourseListPanel.vue?vue&type=script&lang=js&"
import style0 from "./CourseListPanel.vue?vue&type=style&index=0&id=48583387&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48583387",
  null
  
)

export default component.exports